import { render, staticRenderFns } from "./VButton.vue?vue&type=template&id=0518a8ad&"
import script from "./VButton.vue?vue&type=script&lang=js&"
export * from "./VButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0518a8ad')) {
      api.createRecord('0518a8ad', component.options)
    } else {
      api.reload('0518a8ad', component.options)
    }
    module.hot.accept("./VButton.vue?vue&type=template&id=0518a8ad&", function () {
      api.rerender('0518a8ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/VButton.vue"
export default component.exports